/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import cx from 'classnames';
import { BlockAction, BlockActionList, BlockActionListElement } from '../../Blocks/components/common/StyledEditables';


const Actions = ({ options }) => {
  const handleActionClick = (e, action) => {
    e.stopPropagation();

    action();
  };

  return (
    <BlockAction>
      <BlockActionList>
        {options.map((option, i) =>
        <BlockActionListElement
          key={i.toString() + 1}
          onClick={(e) => handleActionClick(e, option.action)}
          className={cx({ active: option.isActive })}>

            {option.label}
          </BlockActionListElement>
        )}
      </BlockActionList>
    </BlockAction>);

};

export default Actions;